import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "./button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./dialog";
import { MutationErrorAlert } from "./mutation-error-alert";
import { TermsAgreementText } from "./terms-agreement-text";
/**
 * "We've updated our Terms." A modal that cannot be dismissed with Escape or a click outside
 * (acceptance is the only way forward) but that never traps the app on a failure: a refused
 * accept shows an alert and the button is live again.
 */
export function TermsUpdateDialog({ open, copy, termsUrl, privacyUrl, isPending, hasError, onAccept, }) {
    return (_jsx(Dialog, { open: open, children: _jsxs(DialogContent, { onEscapeKeyDown: (event) => {
                event.preventDefault();
            }, onPointerDownOutside: (event) => {
                event.preventDefault();
            }, onInteractOutside: (event) => {
                event.preventDefault();
            }, children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: copy.title }), _jsx(DialogDescription, { children: _jsx(TermsAgreementText, { message: copy.message, termsUrl: termsUrl, privacyUrl: privacyUrl }) })] }), hasError ? _jsx(MutationErrorAlert, { messages: [copy.errorMessage], reference: null }) : null, _jsx(DialogFooter, { children: _jsx(Button, { type: "button", disabled: isPending, "aria-busy": isPending, onClick: onAccept, children: isPending ? copy.acceptingLabel : copy.acceptLabel }) })] }) }));
}
TermsUpdateDialog.displayName = "TermsUpdateDialog";
//# sourceMappingURL=terms-update-dialog.js.map